import React, { useEffect, useState } from 'react';
import { ExportTitle, ReportExportContainer, ReportExportContent } from './styles';
import ActionStatus from 'components/ActionStatus';

interface IReportExport {
  tooltipAlert?: boolean
  setTooltipAlert?: React.Dispatch<React.SetStateAction<boolean>>
}
export default function ReportEexport({ tooltipAlert, setTooltipAlert }: IReportExport) {

const [showToolTipAlert, setShowToolTipAlert] = useState(false)

useEffect(() => {
if(tooltipAlert){
  setShowToolTipAlert(true)
  
  setTimeout(() => {
   setShowToolTipAlert(false)
   setTooltipAlert(false)
  }, 5000);
}
}, [tooltipAlert])


  return (
    <ReportExportContainer>
      <ReportExportContent>
        <div className='flex justify-between'>
          <div className='flex flex-col p-8'>
            <ExportTitle>
              Relatório do período
            </ExportTitle>
            <span className='text-darkGray80 text-base'>
              Este relatório possui todas as informações da Unidade selecionada, com período máximo de até 31 dias a partir da data de início.
            </span>
          </div>
        </div>
        {showToolTipAlert && (
          <div className="px-0 mt-5" data-testid="test-tooltip-alert">
            <ActionStatus text={"Relatório exportado com sucesso!"} status={1} />
          </div>
        )}
        
      </ReportExportContent>
    </ReportExportContainer>
  )
}
